<template>
	<div ref="itemList" id="yscrollbarstyle-1" v-on:scroll="OnScroll" class="border rounded p-2 m-2 bg-light overflow-auto yscrollbar" style="min-width: 24em;position: relative;">
		<div class="border-bottom pb-1 justify-content-center align-items-center d-flex" style="padding-left: 30px;">
			<div class="custom-select-dropdown dropdown-gray" text="">
					<!-- <div class="input-group-text custom-select-all">
							<input id="11" type="checkbox" aria-label="Checkbox for following text input">
					</div> -->
					<!--  @click="selectAllCheckbox()" -->
					<div class="form-group">
						<!-- <input type="checkbox" id="css" v-model="isStageCheckBox">
						<label for="css"></label> -->
						<b-form-checkbox 
							class="custom-checkbox-fill" 
							@change="selectAllCheckbox()"
							v-model="isStageCheckBox" 
							name="checkbox-2">
						</b-form-checkbox>
					</div>
					<b-dropdown class="custom-top-dropdown pipelineStageDropdownUI">
						<!-- <template v-slot:button-content>
							<v-icon class="text-blue" scale="1.2" name="ellipsis-v"/>
						</template> -->
						<!-- <b-dropdown-header>
							Delete
						</b-dropdown-header>
						<b-dropdown-item-button @click.stop.prevent="changeStatus(stage)">Delete All</b-dropdown-item-button> -->
						<b-dropdown-header>
							Move to
						</b-dropdown-header>
						<b-dropdown-item-button
							:key="i"
							v-for="(stage, i) in stages"
							v-show="name != stage"
							@click.stop.prevent="changeStatus(stage)"
						>
							{{stage}}
						</b-dropdown-item-button>
						
						<div class="ArchivedDelete" v-if="(name == 'Archived')"><span @click="ArchivedDeleteAll(name)">Delete</span></div>

						<!-- <b-dropdown-divider />
						<b-dropdown-item-button
							v-if="name != 'Archived'"
							@click.stop.prevent="changeStatus('Archived')"
						>
							Archived
						</b-dropdown-item-button> -->
						<!-- <b-dropdown-item-button
							v-if="name != 'Uncatagorized'"
							@click.stop.prevent="changeStatus(null)"
						>
							Uncatagorized
						</b-dropdown-item-button> -->
					</b-dropdown>
			</div>

				<!-- <span v-if="inputnamefetch" class="inputnamefetch">
					
				</span> -->

				
				<!-- <b-button variant="outline-primary" @click="$bvModal.show('updateStageNamePipeline')">Update Pipeline</b-button> -->
				<!-- <b-button variant="outline-primary" @click="updateStageName(name)">Update Pipeline</b-button> -->

				<b-modal :id="`updateStageName${name}`" hide-footer>
					<template v-slot:modal-title>
						{{name}}
					</template>
					<div>
						<b-form-input type="text" id="newStagename" placeholder="Enter ..." label="Pipeline" :value="name" />
						<div class="accdeniedbtn">
							<span class="text-blue deletepipeicon" @click="deleteStageName(name)"><v-icon name="times"></v-icon> Delete</span> 
							<span class="checksetbutton" @click="inputStageNameUpdate(name)"><v-icon name="check" ></v-icon> Update</span>
						</div>	
					</div>
				</b-modal>

			
				<!-- <span v-if="showInput" class="text-blue editpipeicon" @click="editStageName()"><v-icon name="edit" ></v-icon></span>  -->
				<!-- <h5 v-if="showInput" @click="editStageName()" class="stageh5 mb-0 mr-1">{{name}}</h5> -->
				<h5 @click="updateStageName(name)" :title="name" class="stageh5 mb-0 mr-1">{{this.stringDotManage(name)}}</h5>
				<small v-if="prosps" style="color: gray">{{prosps.length}} 
				</small>
				<!-- <span v-if="showInput">
					<download-csv v-if="prosps && prosps.length" style="margin-left: 10px;"
						class="btn-default"
						:data="this.getCSVData()"
						:name="this.getFileName()"
						:fields="reportingFields"
						:labels="reportingLabels"
						>
						<span class="text-blue exportdownloadicon"><v-icon name="download"></v-icon> </span>
					</download-csv>
				</span> -->
			
			
				<span :class="{ 'settingright30': prosps && prosps.length }" class="text-blue settingGearIcon" @click="gearModule(name)"><img src="../../../../../public/img/setting.png" /> </span>

				<b-modal class="gearModaldiv" :id="`gearModule${name}`" hide-footer>
					<template v-slot:modal-title>
						"{{name}}" Stage Settings
						<p class="subheading">When a prospect is moved to this stage...</p>
					</template>
					<div class="bodySection">
						<p class="addthesetaskshead">Add these tasks:</p>
						<div class="row mb-3">
							<div class="col-md-5">
								<b-form-input
								v-model="form.taskDesc"
								placeholder="Enter Task Description" 
								type="text"
								/>
							</div>
							<div class="col-md-5 colpaddleft5">
								<b-form-input
								v-model="form.taskDue"
								placeholder="Enter Days Until Due" 
								type="text"/>
							</div>
							<div class="col-md-2 colpaddleft5">
								<b-button type="submit" block variant="outline-primary" @click="grearModelSubmit(name)">Save</b-button>
							</div>
						</div>
						<b-table :items="getStageSettingsList" :fields="stageFields" striped responsive="sm">
							<template #cell(Actions)="row">
								<b-button size="sm" @click="deleteStageSetting(row.item.id)">
									Delete
								</b-button>
							</template>
						</b-table> 
					</div>	
				</b-modal>
			
				<download-csv v-if="prosps && prosps.length" style="margin-left: 10px;"
					class="btn-default"
					:data="this.getCSVData()"
					:name="this.getFileName()"
					:fields="reportingFields"
					:labels="reportingLabels"
					>
					<span class="text-blue exportdownloadicon"><v-icon name="download"></v-icon> </span>
				</download-csv>

		</div>
		<div class="m-1 d-flex">
			<!-- <b-input type="search" :placeholder="`Search ${name}...`" v-model="search" debounce="500"/> -->
			<b-dropdown v-if="false" variant="outline" toggle-class="mr-1">
				<!-- <b-dropdown-item-button v-if="sort != 0" @click="sort = 0">Recent</b-dropdown-item-button>
				<b-dropdown-item-button v-if="sort != 1" @click="sort = 1">Oldest</b-dropdown-item-button>
				<b-dropdown-item-button v-if="sort != 2" @click="sort = 2">Unread</b-dropdown-item-button> -->

				<b-dropdown-item-button v-if="sort != 0" @click="sort = 0">Recent</b-dropdown-item-button>
				<b-dropdown-item-button v-if="sort != 1" @click="sort = 1">Oldest</b-dropdown-item-button>
				<b-dropdown-item-button v-if="sort != 2" @click="sort = 2">Unread</b-dropdown-item-button>
				<b-dropdown-item-button v-if="sort != 3" @click="sort = 3">Due Task</b-dropdown-item-button>
				<b-dropdown-item-button v-if="sort != 4" @click="sort = 4">Starred</b-dropdown-item-button>
				<b-dropdown-item-button v-if="sort != 5" @click="sort = 5">Scheduled</b-dropdown-item-button>
				<hr>
				<div v-if="user.Folders">
					<h6 class="text-center text-blue">Folders</h6>
					<b-dropdown-item-button
						:key="i"
						@click="folderClick(i)"
						v-for="i in user.Folders.length"
					>
						<span v-if="sort != 5 + i">{{user.Folders[i - 1]}}</span>
					</b-dropdown-item-button>
				</div>
			</b-dropdown>
		</div>
		
		<!--<draggable v-model="items">-->
			<div v-if="sort < 6 && sort >= 0 && renderComponent">
				<ProspectItem :key="prosp.id" v-for="prosp in items" :filter="sort" :selectedSort="selectedSort" :prosp="prosp" @open="emitProsp" />
			</div>
			<div v-if="sort > 5 && renderComponent">
				<ProspectItem :key="prosp.id" v-for="prosp in filterdItems" :filter="sort" :selectedSort="selectedSort" :prosp="prosp" @open="emitProsp" />
			</div>
		<!--</draggable>-->
	</div>
</template>

<script>
	import ProspectItem from './ProspectItem'
	//import draggable from 'vuedraggable'
	import { mapState } from 'vuex'
	import { db } from 'src/db'
	import axios from "axios";

	export default {
		name: "Stage",
		props: {
			name: String,
			prosps: Array,
			selectedSort:Number,
			// isStageCheckBox:Boolean,

		},
		components: {
			ProspectItem,
			//draggable,
		},
		computed: {
			// STAGE SETTING LISTING 
			getStageSettingsList() {
				if(this.user.hasOwnProperty('stageSettings') && this.storeGearStage) {
					let  getLateststageSettingsArray = [];
					getLateststageSettingsArray = this.user.stageSettings.filter(rp => rp.name == this.storeGearStage);
					return getLateststageSettingsArray;
				} else {
					return [];
				}
            },
			items: {
				get() {
					if (!this.prosps) {
						return [];
					}
					let items = this.prosps.filter(prosp => {
						return !this.search || (prosp.Number && prosp.Number.includes(this.search)) ||
							this.$parseNumber(prosp.Number).includes(this.search) ||
							this.$parseAlias(prosp).toLowerCase().includes(this.search.toLowerCase());
					});
					if (items.length == 0) {
						return [];
					}
					if (!this.isStageCheckBox) {
						items.map(i=>i.isSelectedCheck=false);
					}
					
					if (this.selectedSort == 0) {
						switch (this.sort) {
							case 0:
								return items.sort((a, b) => b.DateCreated - a.DateCreated).slice(0, 20 * this.itemListHeight);
							case 1:
								return items.sort((a, b) => a.DateCreated - b.DateCreated).slice(0, 20 * this.itemListHeight);
							case 2:
								return items.sort((a, b) => b.DateCreated - a.DateCreated).slice(0, 20 * this.itemListHeight);
							case 3:
								return this.sortByDueTask(items)
							case 4:
								return this.sortByStarred(items)
							case 5:
								return items.sort((a, b) => b.DateCreated - a.DateCreated).slice(0, 20 * this.itemListHeight);
							default:
								// return this.sortByFolders(items)
								return items.sort((a, b) => b.DateCreated - a.DateCreated).slice(0, 20 * this.itemListHeight);
						}
					}else {
						if (this.selectedSort == 1) {
							return items.sort((a, b) => a.DateCreated - b.DateCreated).slice(0, 20 * this.itemListHeight);
						}
						if (this.selectedSort == 2 || this.selectedSort == 5 || this.selectedSort > 5) {
							if (this.sort == 1) {
								return items.sort((a, b) => a.DateCreated - b.DateCreated).slice(0, 20 * this.itemListHeight);
							}else if (this.sort == 3) {
								return this.sortByDueTask(items)
							}else if (this.sort == 4) {
								return this.sortByStarred(items)
							}else {
								return items.sort((a, b) => b.DateCreated - a.DateCreated).slice(0, 20 * this.itemListHeight);
							}
						}
						
						return items
					}
				},
				set(value) {
					// eslint-disable-next-line
					console.log(value)
				}
			},
			stages() {
				return this.$store.state.firebase.user.Stages;
			},
			...mapState('firebase', ['user', 'prospects', 'convos','emails','calls'])
		},
		methods: {
			deleteConvo(ss) {
				let convoData = this.$store.state.firebase.convos;
				let getConvoData = convoData.find(convo => convo.ClientNumber == ss.Number);
				if(getConvoData) {
					db.doc(`Conversations/${getConvoData.id}`).delete();
				}
			},
			async ArchivedDeleteAll(name) {
				if(name == 'Archived' && this.prosps && this.prosps.length > 0) {
					if (confirm("Are you sure that you want to permanently delete all data associated with the prospects that have been selected?")) {
						let batches = [],
						opCounter = 0,
						i = 0;
						let snap = await db.collection(`Users/${this.user.id}/Prospects`).where('Status', '==', name).get();
						batches.push(db.batch());
						snap.docs.forEach(doc => {
							let ss = this.prosps.find(p => (p.isSelectedCheck == true && p.id == doc.id));
							if (ss) {
								this.deleteConvo(ss);
								batches[i].delete(doc.ref);
								opCounter++;
								if (opCounter === 499) {
									batches[i].commit();
									batches.push(db.batch());
									opCounter = 0;
									i++;
								}
							}
						})
						batches[i].commit();
						await Promise.all(batches);
						this.isStageCheckBox = false;
					}
				} else {
					alert('Please select the checkbox!');
				}
			},
			// STAGE SETTING DELETE 
			deleteStageSetting(rowid) {
				if (confirm("Are you sure you want to delete?")) {
					let stageSettingsArray1 = [];
					Object.assign(stageSettingsArray1,this.user.stageSettings);
					stageSettingsArray1.forEach(a=>{
						if(a.id == rowid) {
							stageSettingsArray1 = stageSettingsArray1.filter((e)=>e.id !== rowid)
						}
					});
					db.doc(`Users/${this.user.id}`).update({stageSettings: stageSettingsArray1});
				}
			},
			// STAGE SETTING SUBMIT 
			grearModelSubmit(name) {
				if(this.form.taskDesc && this.form.taskDue) {
					let stageName = name;
					var stageSettings1 = [];
					if(this.user.hasOwnProperty('stageSettings') && this.user.stageSettings != null || this.user.stageSettings != undefined) {
						stageSettings1 = this.user.stageSettings;
					}
					let stageSettings2 = [{
						'id': this.$uuid.v1(),
						'name': stageName,
						'desc': this.form.taskDesc,
						'due': this.form.taskDue
					}];
					let stageSettingsFinal = [...stageSettings1, ...stageSettings2];
					//eslint-disable-next-line
					console.log('stageSettingsFinal', stageSettingsFinal);
					db.doc(`Users/${this.user.id}`).update({stageSettings: stageSettingsFinal});
					this.form.taskDesc = '';
					this.form.taskDue = '';
				} else {
					alert('Fields must be required.');
				}
			},	
			// STAGE SETTING OPEN POPUP 
			gearModule(name) {
				this.storeGearStage = name;
				this.$bvModal.show(`gearModule${name}`);
			},
			updateStageName(name) {
				this.$bvModal.show(`updateStageName${name}`);
			},

			inputStageNameUpdate(name) {
				let newStageValue = document.getElementById('newStagename').value;
				if(newStageValue != '') {
					// this.showInput = true;
					// this.inputnamefetch = false;
					let oldStagename = name;
					let newStagename = document.getElementById('newStagename').value;
					this.user.Stages.splice(this.user.Stages.indexOf(oldStagename), 1); // REMOVE OLD STAGE NAME

					// USERS: UPDATE STAGE NAME
					let stageArray1 = this.user.Stages; 
					var convertCurrentStagesToUppercase = String(this.user.Stages).toUpperCase().split(","); // CONVERT ALL STAGES UPPER CASE
					var currentStageToUppercase = newStagename.toUpperCase(); // CONVERT CURRENT STAGE UPPER CASE
					if(newStagename) { // CHECK VALUE BLANK OR NOT
						var check = convertCurrentStagesToUppercase.includes(currentStageToUppercase);
						if(!check) { // IF VALUE IS NOT EXIST, PUSH IN ARRAY (true,false)
							stageArray1.push(newStagename);
							db.doc(`Users/${this.user.id}`).update({Stages:stageArray1});
						}
					}

					// PROSPECT: UPDATE THE STAGE NAME IN ARRAY FINDING THE AVAILBLE STAGE
					if(this.prosps && this.prosps.length > 0) {
						this.prosps.forEach(p =>{
							if(p.hasOwnProperty('Stages') && p.Stages.length > 0) {
								let getOnlyLastArray = p.Stages.slice(-1)[0];
								let lastArrayDate = getOnlyLastArray.Date;
								p.Stages.splice(p.Stages.indexOf(getOnlyLastArray), 1);
								var StatusArray1 = [];
								if(p.Stages != null || p.Stages != undefined) {
									StatusArray1 = p.Stages;
								}
								let StatusArray2 = [{Date:lastArrayDate, Stage:newStagename}];
								let StatusArrayFinalOutput = [...StatusArray1, ...StatusArray2];
								let updatedForm = { Stages: StatusArrayFinalOutput, Status:newStagename }
								db.doc(`Users/${this.user.id}/Prospects/${p.id}`).update(updatedForm);
							}
						});
					}
				} else {
					alert('Field must be required.');
				}

			},
			// editStageName() {
			// 	this.showInput = false;
			// 	// this.inputnamefetch = true;
			// }, 
			stageRecursive(e2, currStageName) {
				var updatedForm;
				var getOnlyLastNameArray;
				var setNewStage = [{Date:new Date().valueOf(), Stage:"New"}];
				e2.Stages.splice(e2.Stages.indexOf(currStageName), 1); // REMOVE LAST ARRAY
				getOnlyLastNameArray = e2.Stages.slice(-1)[0]; // GET LAST ARRAY IN CURRENT TIME
				if(getOnlyLastNameArray) {
					var check = this.user.Stages.includes(getOnlyLastNameArray.Stage);
					if(!check) {
						this.stageRecursive(e2, currStageName);
					}
					if(e2.Stages.length == 0) {
						updatedForm = { Stages: setNewStage, Status:"New" }
					} else {
						getOnlyLastNameArray = e2.Stages.slice(-1)[0]; // GET LAST ARRAY IN CURRENT TIME
						updatedForm = { Stages: e2.Stages, Status:getOnlyLastNameArray.Stage }
					}
				} else {
					updatedForm = { Stages: setNewStage, Status:"New" }
				}
				db.doc(`Users/${this.user.id}/Prospects/${e2.id}`).update(updatedForm);
			},
			manageLastStage(name) {
				if(this.prosps && this.prosps.length > 0) {
					var currStageName = name;
					var gotPros = this.prosps.filter(e1 => e1.Status === currStageName);
					if(gotPros) {
						gotPros.forEach(e2 => {
							this.stageRecursive(e2, currStageName);
						});
					}
				}
			},
			deleteStageName(name) {
				// if (confirm(`Are you sure you want to delete '${name}' ?`)) {
				if (confirm(`Deleting this stage will move all prospects currently in '${name}' to their previous stage unless you move them to a different stage first. Are you sure you want to delete '${name}' ?`)) {
					// USERS
					this.user.Stages.splice(this.user.Stages.indexOf(name), 1);
					db.doc(`Users/${this.user.id}`).update({Stages:this.user.Stages});
					// PROSPECTS
					this.manageLastStage(name);
					// if(this.prosps && this.prosps.length > 0) {
					// 	this.prosps.forEach(p =>{
					// 		p.Stages.splice(p.Stages.indexOf(name), 1); // REMOVE LAST ARRAY
					// 		let getOnlyLastNameArray = p.Stages.slice(-1)[0]; // GET LAST ARRAY IN CURRENT TIME 
					// 		let updatedForm = { Stages: p.Stages, Status:getOnlyLastNameArray.Stage }
					// 		db.doc(`Users/${this.user.id}/Prospects/${p.id}`).update(updatedForm);
					// 	});
					// }
				}
			}, 
			// ADD ... IF THE STRING IS MORE THAN 10 DIGITS
			stringDotManage(getString) {
				var result;
				if(getString.length >= 15) {
					result = getString.slice(0, 15)+'...';
				} else {
					result = getString;
				}
				return result;
			},
			getFileName() {
				// return this.user.Company+'-'+this.$parsePlainDate(new Date(this.date_e).getTime())+'-prospects.csv';
				return this.user.Company+'-'+this.$parsePlainDate(new Date(this.date_e).getTime())+'-Prospects-'+this.name+'.csv';
				//return this.user.Company+'-'+this.name+'-stages.csv';
            },
			getCSVData() {
				var getStageCSVData = [];
				// let csvDataJson = this.prosps.sort((a, b) => b.DateCreated - a.DateCreated);
				let csvDataJson = Object.assign(getStageCSVData, this.prosps);
				if (this.downloadCount == 0) {
					this.downloadCount = this.downloadCount+1;
					csvDataJson.sort((a, b) => b.DateCreated - a.DateCreated);
					csvDataJson.forEach(element => {
						let dc = this.$parsePlainDate(element.DateCreated) + '-' + this.$parsePlainTime(element.DateCreated);
						// element.DateCreated = dc;
						element['DateCreatedDuplicte'] = dc;
						/*if (element.Starred == true) {
							element.Starred = 'Yes'
						}else if (element.Starred == false){
							element.Starred = 'No'
						}*/
						if (element.Starred == true) {
							element['DuplicateStarred'] = 'Yes'
						}else if (element.Starred == false){
							element['DuplicateStarred'] = 'No'
						}
						if (element.Notes && element.Notes.length) {
							const newObj = element.Notes.map(key1 => {
								let key11 = this.$parsePlainDate(key1['date']);
								let value = key1['description'];
								return { [key11]:value }
							});
							element['DuplicateNotes'] = JSON.stringify(newObj);                            
						}
						/*if (Object.keys(element.Notes).length) {
							const newObj = Object.keys(element.Notes).map(key => {
								let key11 = this.$parsePlainDate(key)
								let value = element.Notes[key];
								return { [key11]:value }
							});
							element['DuplicateNotes'] = JSON.stringify(newObj);                            
						}*/
					});
				}
				return csvDataJson;
			},
			OnScroll() {
				
				let component = this.$refs.itemList;
				if (component.scrollTop + component.offsetHeight > component.scrollHeight - 1) {
					this.itemListHeight++;
					if (this.sort > 5) {
						this.filterdItems = this.allFilteredItems.sort((a, b) => b.DateCreated - a.DateCreated).slice(0, 20 * this.itemListHeight);
					}
				}
			},
			async folderClick(i) {
				this.sort = 5 + i;
				// let iFolder = this.selectedSort-6;
				// let val = this.user.Folders[iFolder];
				let val2 = this.user.Folders[this.sort-6];

				let prospectList = [];
				let prospectList1 = [];
				// let folderProps = [];
				if (this.selectedSort > 5) {
					for (let item of this.prosps) {
						if (item.hasOwnProperty('Tags') && item.Tags && item.Tags.includes(val2)) {
							prospectList.push(item)
						}
					}
				}else {
					let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Tags', 'array-contains', val2).get();
					prospectList = colRef.docs.map((doc) => {
						let data = { id: doc.id, ...doc.data() };
						return data;
					});
					let colRef1 = await db.collection(`Users/${this.user.id}/Prospects`).where('Tags', '==', val2).get();
					prospectList1 = colRef1.docs.map((doc) => {
						let data = { id: doc.id, ...doc.data() };
						return data;
					});
					// let abc = [];
					// for (let item of prospectList1) {
					// 	if (item.hasOwnProperty('Tags') && item.Tags && item.Tags.includes(val2)) {
					// 		abc.push(item)
					// 	}
					// }
					// for (let item of this.prosps) {
					// 	if (item.Status == 'New' && item.hasOwnProperty('Tags') && item.Tags && item.Tags.includes(val2)) {
					// 		folderProps.push(item)
					// 	}
					// }
				}
				prospectList = prospectList.concat(prospectList1);
				let folderProps = [];
				for (let item of prospectList) {
					if (item.hasOwnProperty('Status') && item.Status == this.name) {
						folderProps.push(item)
					}
				}
				this.allFilteredItems = folderProps;
				this.filterdItems = this.allFilteredItems.sort((a, b) => b.DateCreated - a.DateCreated).slice(0, 20 * this.itemListHeight);
				// this.scroll()
				
			},
			async emitProsp(prosp, convo) {
				// eslint-disable-next-line
				console.log("hello");

				let convoSnap = await db.collection('Conversations')
					.where('ClientNumber', '==', prosp.Number)
					.where('Uid', '==', this.user.Uid)
					.orderBy('DateUpdated', 'desc')
					.get();
					let convoData = convoSnap.docs.map(doc => ({
										id: doc.id, 
										...doc.data(),
									}));
				// eslint-disable-next-line
				console.log('convoSnap', convoData);
				// eslint-disable-next-line
				console.log('convos', this.convos);

				let newConvo = convoData[0];
                if (newConvo && !this.convos.some(convo => convo.id === newConvo.id)) {
				var newN = [...this.convos,newConvo];
				this.$store.commit('firebase/SET', { var: 'searchConvo', val: newN });
				}

				this.search = '';
				if(!prosp.hasOwnProperty('Number') || prosp.Number == '' || prosp.Number === 'undefined') {
					this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
					this.$store.commit('globals/CLEAR', 'activeConvo');
				} else {
				/*if (!convo) {
					convo = await db.collection('Conversations').add({
						ClientNumber: prosp.Number,
						AgentNumber: this.user.Twilio,
						Uid: this.user.Uid,
						LastMessage: '',
						DateUpdated: 0,
						Unread: 0
					});
				}*/
				
				if (!convo) {
					let passData = {
						AgentNumber: this.user.Twilio,
						ClientNumber: prosp.Number,
						Uid: this.user.Uid
					};
					await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/addConvoOnceNumberValidate", passData)
					.then(response => {
						//eslint-disable-next-line
						console.log("Response: ", response);
						setTimeout(() => {
							let convo1 = this.convos.find(convo => convo.ClientNumber == prosp.Number);
							this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
							this.$store.commit('globals/SET', { var: 'activeConvo', val: convo1.id });
							this.$store.dispatch('firebase/bindMessages', convo1.id);
							
							if (this.emails && this.emails.length) {
								let mid = this.getEmailConvoID(prosp.id);
								if (mid) {
									this.$store.dispatch('firebase/bindMails', mid);
								}else {
									this.$store.dispatch('firebase/clearonlyMailsData');
								}
								// this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(task.singleProsp.id));
							}
							if(this.calls != null && this.calls.length){
								let cid = this.getCallsConvoID(prosp.id);
								if (cid) {
										this.$store.dispatch('firebase/bindPhones', cid);
									}else {
										this.$store.dispatch('firebase/clearonlyPhonesData');
									}
								}

						}, 300);
					}).catch(err => alert(`Something wrong in data: ${err}`));
				} else {

				this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: convo.id });
				this.$store.dispatch('firebase/bindMessages', convo.id);

				if (this.emails && this.emails.length) {
                    let mid = this.getEmailConvoID(prosp.id);
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
                    // this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(task.singleProsp.id));
                }
				if(this.calls != null && this.calls.length){
				let cid = this.getCallsConvoID(prosp.id);
				if (cid) {
						this.$store.dispatch('firebase/bindPhones', cid);
					}else {
						this.$store.dispatch('firebase/clearonlyPhonesData');
					}
				}
				}
				}
				this.$emit('open');
			},
			getEmailConvoID(prospId) {
				let mailid = '';
				let mail = this.emails.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (mail) {
					mailid = mail.id;
				}
				return mailid;
			},
			getCallsConvoID(prospId) {
				let phoneid = '';
				let phone = this.calls.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (phone) {
					phoneid = phone.id;
				}
				return phoneid;
			},
			scroll() {
				this.$refs.itemList.onscroll = () => {
					let component = this.$refs.itemList;
					if (component.scrollTop + component.offsetHeight > component.scrollHeight - 1) {
						this.itemListHeight++;
					}
				};
			},
			sortByDueTask(items) {
				let dueProps = [];
				for (let item of items) {
					if (this.isOverDue(item)) {
						dueProps.push(item)
					}
				}
				return dueProps
			},
			sortByStarred(items) {
				let starredProsp = [];
				for (let item of items) {
					if (item && item.hasOwnProperty('Starred') && item.Starred) {
						starredProsp.push(item)
					}
				}
				return starredProsp
			},
			sortByFolders(items) {
				let folderProps = [];
				let iFolder = this.sort-5;
				for (let item of items) {
					if (item.hasOwnProperty('Tags') && item.Tags && item.Tags.includes(this.user.Folders[iFolder])) {
						folderProps.push(item)
					}
				}
				// let val = this.user.Folders[iFolder];
				// let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Tags', 'array-contains', val).get();
			
				// let prospectList = colRef.docs.map((doc) => {
				// 	let data = { id: doc.id, ...doc.data() };
				// 	return data;
				// })
				// return prospectList
				return folderProps
				
				
			},
			isOverDue(findProps) {
				let val = false;
				if(findProps && findProps.Tasks) {
					for (let task of findProps.Tasks) {
						if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now() || this.con(new Date(task.DueOn)))) {
							val = true;
							break	
						}
					}
					
				}
				return val
			},
			selectAllCheckbox() {
				
				// this.items.map(i=>i.isSelectedCheck=!this.isStageCheckBox);
				this.prosps.map(i=>i.isSelectedCheck=!this.isStageCheckBox);
				// Remove component from the DOM
				this.renderComponent = false;
				this.$nextTick(() => {
				// Add the component back in
					this.renderComponent = true;
				});
			},
			async insertTheNewTask(getLateststageSettingsArray, k, prospid) {
				let nowUTC = new Date().valueOf(); // CURRENT DATE/TIME
				let nowUTCAdded = nowUTC + (getLateststageSettingsArray[k]['due'] * (24 * 60 * 60 * 1000))
				const taskData = {
					pid : this.user.id,
					cid : prospid,
					taskName : getLateststageSettingsArray[k]['desc'],
					dueDate : nowUTCAdded,
				};
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/createTask", taskData)
				.then(response => {
					//eslint-disable-next-line
					console.log("New Task Added Successfully", response);
				});
			},
			async changeStatusinsertTheNewTask(ss, status) {
				if(this.user.hasOwnProperty('stageSettings')) {
					let  getLateststageSettingsArray = [];
					getLateststageSettingsArray = this.user.stageSettings.filter(rp => rp.name == status);
					for(var k=0; k < getLateststageSettingsArray.length;) {
						await this.insertTheNewTask(getLateststageSettingsArray, k, ss.id);
						k++;
					}
				}
			},
			async changeStatus(status) {
				// let user = this.$store.state.firebase.user;
				// db.doc(`Users/${user.id}/Prospects/${this.prosp.id}`).update({ 'Status': status })
				// this.renderComponent = false;
				let batches = [],
				opCounter = 0,
				i = 0;
				// let snap = await db.collection(`Users/${this.user.id}/Prospects`).get();
				let snap = await db.collection(`Users/${this.user.id}/Prospects`).where('Status', '==', this.name).get();
				// let prospectList1 = snap.docs.map((doc) => {
				// 	let data = { id: doc.id, ...doc.data() };
				// 	return data;
				// });
				batches.push(db.batch());
				snap.docs.forEach(doc => {
					// let updatedTags = doc.data().Tags.filter(tag => after.Folders.includes(tag));
					// let c = this.convos.find(convo => convo.ClientNumber == data.Number);
					let ss = this.prosps.find(p => (p.isSelectedCheck == true && p.id == doc.id));
					if (ss) {
						
						this.changeStatusinsertTheNewTask(ss, status);
						
					// if (updatedTags.length !== doc.data().Tags.length) {
						var StatusArray1 = [];
						if(ss.Stages != null || ss.Stages != undefined) {
							StatusArray1 = ss.Stages;
						}

						let StatusArray2 = [{Date:new Date().valueOf(), Stage:status}];
						let StatusArrayFinalOutput = [...StatusArray1, ...StatusArray2];
						batches[i].update(doc.ref, { "Status": status, "Stages": StatusArrayFinalOutput });
						opCounter++;
						if (opCounter === 499) {
							batches[i].commit();
							batches.push(db.batch());
							opCounter = 0;
							i++;
						}
					// }
					}
				})
				batches[i].commit();
				await Promise.all(batches);
				this.isStageCheckBox = false;
				// this.$emit('clicked-show-detail', this.isStageCheckBox);
			},
		},
		data() {
			return {
				// storeStage: '',
				date_e:new Date(),
				itemListHeight: 1,
				search: '',
				sort: 0,
				form:{
					taskDesc: '',
					taskDue: '',
				},
				filterdItems:[],
				allFilteredItems:[],
				isStageCheckBox: false,
				renderComponent: true,
				storeGearStage: '',
				reportingFields:['DateCreatedDuplicte','First','Last','Email','Number','Zip','Status','DuplicateStarred','Source','Tags','DuplicateNotes'],
                reportingLabels:{
                    DateCreatedDuplicte: 'Date Created',
                    First: 'First Name',
                    Last: 'Last Name',
                    Number: 'Phone Number',
                    Zip:'Zip Code',
					DuplicateStarred:'Starred',
                    DuplicateNotes:'Notes'
                },
				downloadCount:0,

				stageFields: [
                    {'key':'desc',label: 'Task Description',  sortable: true}, 
                    {'key':'due', label: 'Days Until Due', sortable: true}, 
					'Actions',
				],

				// inputnamefetch:false,
				// showInput:true,
				

			}
		},
		mounted() {
			this.scroll();
		}
	}
</script>

<style scoped>
/* .editpipeicon{
	background: #007bff;
    color: #fff;
    padding: 8px 10px;
    border-radius: 5px;
    cursor: pointer;
} */
.deletepipeicon{
	background: #afafaf;
    color: #fff;
    padding: 8px 10px;
    border-radius: 5px;
    cursor: pointer;
	margin-right: 8px;
}
.custom-select-all label {
    margin: 0;
}

.custom-select-all input[type="checkbox"] {
    margin-right: 10px;
}

.custom-select-dropdown button.dropdown-item {
    padding: 0px 10px !important;
}

.custom-select-dropdown .input-group-text.custom-select-all {
    padding: 0;
    background: transparent;
    border: transparent;
}
.custom-select-dropdown {
    position: absolute;
    left: 14px;
    top: 10px;
    display: flex;
    align-items: center;
}
.form-group {
  display: block;
  margin-bottom: 0px;
}

.form-group input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.stageh5{
	font-size:14px;
	cursor: pointer;
}
.form-group label {
  position: relative;
  cursor: pointer;margin: 0;
}

.form-group label:before {
  content:'';
  -webkit-appearance: none;
  background-color: transparent;
  border: 2px solid #042b79;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 10px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 0px;
}
.form-group input:checked + label:before{
	background-color: #042b79;
}

.form-group input:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 4px;
  left: 9px;
  width: 6px;
  height: 14px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.form-group:hover{
	background-color:#ced3de;
}
.custom-select-dropdown .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle{
	background-color: transparent;
    border-color: transparent;
	color:inherit;
}
.exportdownloadicon{
	padding: 0px 5px;
    float: right;
    position: absolute;
    right: 6px;
    top: 5px;
    border-radius: 2px;
    cursor: pointer;
}
.settingGearIcon{
	padding: 0px 5px;
    float: right;
    position: absolute;
    right: 0px;
    top: 5px;
    border-radius: 2px;
    cursor: pointer;
}
.settingright30{
	right: 30px;
}
.subheading{
	font-size: 14px;
    color: #838383;
    margin: 0;
    padding: 5px 0px 0px 0px;
    font-weight: normal;
}


.bodySection .colpaddleft5{
	padding-left:5px;
}
.bodySection input{
	border-radius: 0px;
	height:35px;
	font-size: 13px;
}
.bodySection .addthesetaskshead{
	font-size: 13px;
}

</style>
<style>
.gearModaldiv .modal-dialog{
	width:600px;	
}


/* .inputnamefetch{
	position: relative;
} */
.accdeniedbtn{
	margin-top:20px;
	text-align: right;
}
.checksetbutton{
	background: #007bff;
    /* position: absolute; */
	color: #fff;
    padding: 8px 10px;
    border-radius: 5px;
    cursor: pointer;
    /* right: 0px;
    top: 0px;
    padding: 6px 10px;
    cursor: pointer;
    border-radius: 2px; */
}
.ArchivedDelete{
	text-align: center;
    color: #dc5757;
    padding: 3px;
	font-size: 13px;
}
.ArchivedDelete span{
	cursor: pointer;
}
</style>

